<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { AvatarRoot } from "radix-vue"
import { useClass } from "~/composables/local/cn-class"
import { avatarVariant, type AvatarVariants } from "."

const {
	size = "sm",
	shape = "circle",
	...props
} = defineProps<{
	class?: HTMLAttributes["class"]
	size?: AvatarVariants["size"]
	shape?: AvatarVariants["shape"]
}>()

const avatarVarientClass = computed(() => avatarVariant({ size, shape }))

const className = useClass(
	avatarVarientClass,
	() => props.class,
)
</script>

<template>
	<AvatarRoot :class="className">
		<slot />
	</AvatarRoot>
</template>
